<template>
    <div>   
      <b-row>
          <b-col class="p-md-4">
              <b-row>
                  <b-card class="m-auto">
                    <b-form inline>
                        <label class="mr-2">Tipo de Comprobante</label>
                        <b-form-select v-model="tipoSelected" :options="tipoComprobante" class="mr-sm-2" />
                        <label class="mr-2">Fecha</label>
                        <datepicker v-model="date" :format="customFormatter" :language="es" :bootstrap-styling="true"></datepicker>
                        <template v-if="!loading">             
                            <b-button variant="primary" @click="getDocs" class="consultar"><i class="fa fa-search"></i> Consultar</b-button>
                        </template>
                        <template v-else>
                            <b-button disabled variant="secondary" class="consultar"><i class="fa fa-spin fa-spinner"></i> Consultando</b-button>
                        </template>                
                    </b-form>
                </b-card>
              </b-row>
              <br>          
              <b-row>     
                  <b-col>
                    <b-card v-if="items.length>0">
                        <template slot="header">
                            <b-row align-v="center">
                                <b-col md="4">
                                    Comprobantes Obtenidos
                                </b-col>
                                <b-col md="5">
                                    <b-form inline class="m-auto">
                                        <label class="mr-1">Filtro</label>
                                            <b-input-group class="mb-2 mr-sm-2 mb-sm-0">
                                                <b-input-group-text slot="prepend">
                                                    <i class="fa fa-filter"></i>
                                                </b-input-group-text>
                                                <b-form-input v-model="filter"></b-form-input>
                                                <b-input-group-text slot="append" @click="clearfilter">
                                                    <i class="fa fa-eraser"></i>
                                                </b-input-group-text>                                                
                                            </b-input-group>                                            
                                    </b-form>
                                </b-col>
                                <b-col md="3">
                                    <b-form inline class="m-auto">
                                        <label class="mr-1">Mostrar</label>
                                            <b-input-group class="mb-2 mr-sm-2 mb-sm-0">                                                
                                                <b-form-select :options="pageOptions" v-model="limit" @input="getDocs()"/>                                                                                             
                                            </b-input-group>                                            
                                    </b-form>                                    
                                </b-col>
                            </b-row>    
                        </template>             
                        <b-table responsive striped small :items="items" :fields="itemsfields" :filter="filter">
                            <template slot="receptor" slot-scope="data">
                                {{data.item.idReceptor}} 
                                <template v-if="data.item.receiver">
                                    - {{data.item.receiver.razonSocial}}
                                </template>   
                            </template>
                            <template slot="gravado" slot-scope="data">
                                    <template v-if="data.item.tipoMoneda=='PEN'">S/</template>
                                    <template v-else-if="data.item.tipoMoneda=='USD'">$</template>
                                    <template v-else>{{ data.item.tipoMoneda }}</template>                     
                                    {{data.item.totalVentaGravada}}
                            </template>
                            <template slot="igv" slot-scope="data">
                                    <template v-if="data.item.tipoMoneda=='PEN'">S/</template>
                                    <template v-else-if="data.item.tipoMoneda=='USD'">$</template>
                                    <template v-else>{{ data.item.tipoMoneda }}</template>                     
                                    {{data.item.sumatoriaIgv}}
                            </template>
                            <template slot="moneda" slot-scope="data">
                                    <template v-if="data.item.tipoMoneda=='PEN'">S/</template>
                                    <template v-else-if="data.item.tipoMoneda=='USD'">$</template>
                                    <template v-else>{{ data.item.tipoMoneda }}</template>                     
                                    {{data.item.importeTotal}}
                            </template>
                            <template slot="acciones" slot-scope="data">
                                <template v-if="data.item.emitido==1">
                                <b-button-group>
                                    <b-button variant="primary" size="sm" v-b-tooltip.hover.rightbottom title="Agregar" @click="addDoc(data.item, data.index)"><i class="fa fa-plus"></i></b-button>
                                </b-button-group>                      
                                </template>
                            </template>
                        </b-table>
                        <b-row>
                            <b-col>
                                <div class="float-left">
                                    <p>Mostrando del {{desde}} al {{hasta}} de un total de {{total}} registros</p>
                                </div>
                            </b-col>
                            <b-col>
                                <div class="float-right">
                                    <b-pagination size="sm" :total-rows="total" v-model="currentPage" :per-page="limit" @input="getDocs()">
                                </b-pagination>
                                </div>                                
                            </b-col>
                        </b-row>
                    </b-card>
                  </b-col>
              </b-row>
          </b-col>
          <b-col class="p-md-4">              
              <b-row>
                  <b-col>
                      <b-card v-if="selectedItems.length>0">
                        <template slot="header">
                            <b-row align-v="center">
                                <b-col>
                                    Comprobantes Elegidos para dar de Baja
                                </b-col>                                
                            </b-row>    
                        </template>                                                
                        <b-table striped small hover :items="selectedItems" :fields="selectedItemsfields">
                            <template slot="receptor" slot-scope="data">
                                {{data.item.idReceptor}} 
                                <template v-if="data.item.receiver">
                                    - {{data.item.receiver.razonSocial}}
                                </template>    
                            </template>
                            <template slot="gravado" slot-scope="data">
                                    <template v-if="data.item.tipoMoneda=='PEN'">S/</template>
                                    <template v-else-if="data.item.tipoMoneda=='USD'">$</template>
                                    <template v-else>{{ data.item.tipoMoneda }}</template>                     
                                    {{data.item.totalVentaGravada}}
                            </template>
                            <template slot="igv" slot-scope="data">
                                    <template v-if="data.item.tipoMoneda=='PEN'">S/</template>
                                    <template v-else-if="data.item.tipoMoneda=='USD'">$</template>
                                    <template v-else>{{ data.item.tipoMoneda }}</template>                     
                                    {{data.item.sumatoriaIgv}}
                            </template>
                            <template slot="moneda" slot-scope="data">
                                    <template v-if="data.item.tipoMoneda=='PEN'">S/</template>
                                    <template v-else-if="data.item.tipoMoneda=='USD'">$</template>
                                    <template v-else>{{ data.item.tipoMoneda }}</template>                     
                                    {{data.item.importeTotal}}
                            </template>
                            <template slot="acciones" slot-scope="data">
                                <template v-if="data.item.emitido!=2">
                                <b-button-group>
                                    <b-button v-b-tooltip.hover variant="danger" title="Quitar" @click="remDoc(data.item, data.index)"><i class="fa fa-times"></i></b-button>
                                </b-button-group>                      
                                </template>
                            </template>
                        </b-table>
                        <template slot="footer">
                            <b-button variant="warning" v-b-modal.modalpreproccess v-b-tooltip.hover title="Procesar"><i class="fa fa-save"></i> Procesar</b-button>
                        </template>                        
                    </b-card>
                  </b-col>
              </b-row>
          </b-col>
          <b-modal id="modalpreproccess" v-model="modal">
              <template slot="modal-title">
                  <i class="fa fa-exclamation-triangle text-danger"></i> Dar de baja a comprobantes
              </template>
                <p class="my-4 h4"><b>{{this.$store.getters.userData.username}}</b>, realmente desea dar de baja los siguientes comprobantes?</p>
                <b-list-group>
                    <template v-for="item in selectedItems">
                        <template v-if="item.receiver">
                            <b-list-group-item :key="item.numero">{{item.serie + '-' + item.numero + ' | ' + item.idReceptor + '-' + item.receiver.razonSocial}}</b-list-group-item>
                        </template>
                        <template v-else>
                            <b-list-group-item :key="item.numero">{{item.serie + '-' + item.numero + ' | ' + item.idReceptor }}</b-list-group-item>
                        </template>
                    </template>
                    
                </b-list-group>
                <br>
                <b-alert v-if="!loading2" variant="danger" show>El siguiente procedimiento no se puede deshacer.</b-alert>
                <b-alert v-else variant="danger" show>Estamos dando de baja los documentos indicados.</b-alert>
              <template slot="modal-footer">
                  <template v-if="!loading2">
                    <b-button variant="secondary" @click="modal=false">No</b-button>
                    <b-button variant="danger" @click="processDocs"><i class="fa fa-cog"></i> Procesar</b-button>
                  </template>
                  <b-button v-else disabled variant="danger"><i class="fa fa-spin fa-cog"></i> Procesando</b-button>
              </template>  
          </b-modal>         
    </b-row>
    <vue-snotify></vue-snotify>
    </div>   
</template>

<script>
import axios from 'axios'
import Datepicker from 'vuejs-datepicker'
import {es} from 'vuejs-datepicker/dist/locale'
export default {
    components: {
      Datepicker,
    },
    name: 'ComunicacionBajaEmision',
    mounted() {
        this.customFormatter()
        // this.getDocs()
    },
    data: () => {
        return {            
            loading: false,
            loading2: false,
            modal: false,
            tipoComprobante:[ 
                {
                    value: '01',
                    text: 'Factura'
                },
                {
                    value: '07',
                    text: 'NC Factura'
                },
                // {
                //     value: '03',
                //     text: 'Boleta'
                // },
                {
                    value: '08',
                    text: 'ND Factura'
                }
            ],
            tipoSelected: '01',
            date: new Date(),
            items: [],
            itemsfields: [
                {key:'serie', label:'Serie', sortable: true},
                {key:'numero', label: 'N°', sortable: true},
                {key:'receptor', label: 'Receptor'},
                {key:'gravado', label: 'Subtotal'},
                {key:'igv', label:'IGV'},
                {key:'moneda', label: 'Total'},
                {key:'acciones', label:'Acciones'}
            ],
            limit: 15,
            currentPage: 1,
            total: 0,
            desde: 0,
            hasta: 0,
            es: es,
            pageOptions: [1,5,10,15,25],
            filter: null,
            selectedItems: [],
            selectedItemsfields: [
                {key:'serie' , label:'Serie' ,},
                {key:'numero', label: 'Numero',},
                {key:'receptor', label: 'Receptor'},
                {key:'gravado', label: 'Subtotal'},
                {key:'igv', label:'IGV'},
                {key:'moneda', label: 'Total'},
                {key:'acciones', label:'Acciones'}
            ]
        }
    },
    methods:{
        customFormatter: function (date) {
            return this.$moment(date).format('YYYY-MM-DD');
        },
        getDocs: function () {
            this.loading = true
            this.items = []
            if(this.tipoSelected=='01')
            {
                axios
                .post(process.env.VUE_APP_API_URL + 'facturas/porfecha', {
                    token: this.$store.getters.userToken,
                    date: this.$moment(this.date).format('YYYY-MM-DD'),
                    page: this.currentPage,
                    limit: this.limit    
                })
                .then(response => (
                    this.items = response.data.data,
                    this.limit = response.data.per_page,
                    this.total = response.data.total,
                    this.currentPage = response.data.current_page,
                    this.desde = response.data.from,
                    this.hasta = response.data.to,
                    this.loading = false
                    ))
                .catch(function (error) {
                    this.loading = false
                })
            }
            else if(this.tipoSelected=='03')
            {
                axios
                .post(process.env.VUE_APP_API_URL + 'boletas/porfecha', {
                    token: this.$store.getters.userToken,
                    date: this.$moment(this.date).format('YYYY-MM-DD')  ,
                    page: this.currentPage,
                    limit: this.limit                   
                })
                .then(response => (
                    this.items = response.data.data,
                    this.limit = response.data.per_page,
                    this.total = response.data.total,
                    this.currentPage = response.data.current_page,
                    this.desde = response.data.from,
                    this.hasta = response.data.to,
                    this.loading = false
                    ))
                .catch(function (error) {
                    this.loading = false
                })
            }
            else if(this.tipoSelected=='07')
            {
                axios
                .post(process.env.VUE_APP_API_URL + 'notacredito/factura/porfecha', {
                    token: this.$store.getters.userToken,
                    date: this.$moment(this.date).format('YYYY-MM-DD'),
                    page: this.currentPage,
                    limit: this.limit                
                })
                .then(response => (
                    this.items = response.data.data,
                    this.limit = response.data.per_page,
                    this.total = response.data.total,
                    this.currentPage = response.data.current_page,
                    this.desde = response.data.from,
                    this.hasta = response.data.to,
                    this.loading = false
                    ))
                .catch(function (error) {
                    this.loading = false
                })
            }
            else if(this.tipoSelected=='08')
            {
                axios
                .post(process.env.VUE_APP_API_URL + 'notadebito/factura/porfecha', {
                    token: this.$store.getters.userToken,
                    date: this.$moment(this.date).format('YYYY-MM-DD'),
                    page: this.currentPage,
                    limit: this.limit                 
                })
                .then(response => (
                    this.items = response.data.data,
                    this.limit = response.data.per_page,
                    this.total = response.data.total,
                    this.currentPage = response.data.current_page,
                    this.desde = response.data.from,
                    this.hasta = response.data.to,
                    this.loading = false
                    ))
                .catch(error => (
                    this.loading = false
                ))
            }
        },
        clearfilter: function () {
            this.filter = null
        },
        addDoc: function(item, index){
            this.selectedItems.push(item)
            this.items.splice(index,1)
        },
        remDoc: function(item, index){
            this.items.push(item)
            this.selectedItems.splice(index,1)
        },
        processDocs: function (){
            this.loading2 = true
            let items = [];
            this.selectedItems.forEach(function (element) {
                let item = {}
                item.descripcion = 'Baja'
                item.serie = element.serie
                item.numero = element.numero
                if(element.idFactura)
                {
                    item.tipoComprobante = '01'
                }
                else if(element.idBoleta)
                {
                    item.tipoComprobante = '03'
                }
                else if(element.idNotaCredito)
                {
                    item.tipoComprobante = '07'
                }
                else if(element.idNotaDebito)
                {
                    item.tipoComprobante = '08'
                }
                items.push(item)
            });
            axios
            .post(process.env.VUE_APP_API_URL + 'comunicacionbaja/emitir', {
                token: this.$store.getters.userToken,
                fechaEmisionDocs: this.$moment(this.date).format('YYYY-MM-DD'),
                items: items
            })
            .then(response => (                
            this.loading2 = false,
            this.modal = false,
            this.$snotify.success(response.data.msg, 'Éxito'),
            this.selectedItems = [],
            this.getDocs()
                ))
            .catch((error) => ((
                this.loading2 = false,
                this.modal = false,
                this.$snotify.error(error.response.data.response.description, 'Error')
            ))) 
        }
    }
    
}
</script>
<style scoped>
.form-inline {    
    flex-flow: inherit;
}
.consultar{
    margin-left: 20px;
}
</style>


